// removed by extract-text-webpack-plugin
module.exports = {"footerContainer":"footerContainer_1NPLj","solutionList":"solutionList_2KpHY","contactList":"contactList_1hF8-","logo":"logo_1eFDg","qrcode":"qrcode_3WWjb","copyright":"copyright_r6zPX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/index.scss
// module id = 138
// module chunks = 15